@if (page$ | async; as page) {
  <div class="main">
    @if (filter$ | async; as filter) {
        <div>
          <redispatch-netzzuordnungen-filter
            [initialFilter]="filter"
            (filter)="filterChanged($event)"
          ></redispatch-netzzuordnungen-filter>
        </div>
        @if (netzzuordnungenPage$ | async; as netzzuordnungPage) {
          <div
            data-qa="netzzuordnungen-result">
            <redispatch-netzzuordnungen-table [netzzuordnungen]="netzzuordnungPage.content"
              [netzbetreiberType]="profile.netzbetreiberType"
              [sortActive]="page.sort"
              [sortDirection]="page.direction"
              (sortChange)="sortChange($event)"
              >
            </redispatch-netzzuordnungen-table>
            <mat-paginator #paginator
              [showFirstLastButtons]="false"
              [hidePageSize]="true"
              [pageSize]="PAGE_SIZE"
              [pageIndex]="page.page"
              [length]="netzzuordnungPage.totalElements"
              (page)="pageChange($event)"
              >
            </mat-paginator>
          </div>
        }
    }
  </div>
}

